import { Radio, Space } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';

import useEscrowAccount from '@/hooks/useEscrowAccount';
import { useUserInfo } from '@/hooks/useUserInfo';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useI18nContext } from '@/i18n/I18n';
import {
  getDepositList,
  getV3MemberPreference,
  setV3MemberPreference,
} from '@/services/setting';
import {
  IDepositList,
  IV3MemberPreferenceResult,
} from '@/services/types/settings';
import { useUserStore } from '@/store/useUser';
import { complianceExtData } from '@/utils/complianceHelpers';

const Recharge = () => {
  const [$t] = useI18nContext();
  const { msgError } = useUserInfo();
  const { isUta, profile: user } = useUserProfile();
  const [transferAccount, setTransferAccount] = useState<string>('contract');
  const [oldTransferAccount, setOldTransferAccount] =
    useState<string>('contract');
  const [autoTransferClickFlag, setAutoTransferClickFlag] =
    useState<boolean>(false);
  const [depositList, setDepositList] = useState<string[]>([]);
  const { onlySetUtaDepositInstitution } = useEscrowAccount();

  const { complianceConfig } = useUserStore();

  useEffect(() => {
    if (user && user.result) {
      getV3MemberConfigs();
    }
  }, [user]);
  // 获取用户 充值默账户
  const getV3MemberConfigs = useCallback(() => {
    getV3MemberPreference({ config_keys: ['deposit_to'] })
      .then((res) => {
        const result = res as IV3MemberPreferenceResult;
        const configs = result.configs;

        setTransferAccount(configs.deposit_to || '');
        setOldTransferAccount(configs.deposit_to || '');
      })
      .catch(() => {
        setTransferAccount('contract');
      });
  }, []);

  // 切换默认资产转换账户
  const autoTransferChange = (val: any) => {
    const e = val.target.value;
    if (autoTransferClickFlag) return;
    setAutoTransferClickFlag(true);
    setV3MemberPreference({
      upsert_config_info: {
        deposit_to: e,
      },
    })
      .then((res: any) => {
        if (res.ret_code === 0) {
          setTransferAccount(e);
        } else {
          // 设置失败
          msgError(res);
          setTransferAccount(oldTransferAccount);
        }
      })
      .catch((err) => {
        msgError(err);
        setTransferAccount(oldTransferAccount);
      })
      .finally(() => {
        setAutoTransferClickFlag(false);
      });
  };

  // 可充值帐户翻译映射
  const depositTranslateMap = {
    spot: $t('autoTransferToSopt'),
    contract: $t('autoTransferToContract'),
    option_usdc: $t('autoTransferToUsdcContract'),
    inverse_contract: $t('autoTransferToReverseContract'),
    unified: $t('autoTransferToUnifield'),
    uta: $t('autoTransferTo').replace('{account}', $t('autoTransferToUta')),
    fund: $t('autoTransferTo').replace('{account}', $t('autoTransferToFund')),
  };
  // 获取可充值帐户
  useEffect(() => {
    getDepositList()
      .then((res) => {
        const { deposit } = res as IDepositList;
        setDepositList(deposit);
      })
      .catch(() => {
        setDepositList([]);
      });
  }, []);

  const checkDisabled = (deposit: string) => {
    if (onlySetUtaDepositInstitution) {
      // 部分托管商只能设置充值至uta帐户
      return deposit !== 'uta';
    }
    return false;
  };

  return depositList.length ? (
    <div className="recharge-container">
      <h3 className="recharge-setup-title">{$t('Deposit')}</h3>
      <div className="recharge-setup-form">
        <div className="recharge-setup-form-item-switch">
          <Radio.Group onChange={autoTransferChange} value={transferAccount}>
            <Space direction="vertical">
              {depositList.map((deposit) => {
                if (
                  (
                    complianceExtData(complianceConfig?.RechargeAccountList)
                      ?.hideList || []
                  ).includes(deposit)
                ) {
                  return null;
                }
                if (!isUta && deposit === 'option_usdc') {
                  return null;
                }
                return (
                  <Radio
                    key={deposit}
                    value={deposit}
                    disabled={checkDisabled(deposit)}
                  >
                    {
                      depositTranslateMap[
                        deposit as keyof typeof depositTranslateMap
                      ]
                    }
                  </Radio>
                );
              })}
            </Space>
          </Radio.Group>
        </div>
      </div>
    </div>
  ) : null;
};
export default Recharge;
